import { formatDate } from '~/utils/date';

/**
 * 입고예정일시를 포맷팅하는 함수
 * @param receivingExpectedDate - 입고예정일
 * @param receivingExpectedTime - 입고예정시간
 * @returns 포맷팅된 입고예정일시 문자열 (예: `2024.01.07 (00:00~23:59)` 또는 `2024.01.07`)
 */
export const formatReceiveExpectedDateTime = (
  receivingExpectedDate: string | null | undefined,
  receivingExpectedTime: string | null | undefined
): string => {
  const formattedDate = formatDate(receivingExpectedDate, 'YYYY.MM.DD') ?? '-';

  return receivingExpectedTime ? `${formattedDate} (${receivingExpectedTime})` : formattedDate;
};
